module.exports = __webpack_public_path__ + "static/momo-7bd1f6cd4261bd99864582aadf878e08.webp";